import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
import * as component from "./modules/components";

const fileInput = document.getElementById("fileInput");
const imageContainer = document.getElementById("imageContainer");
const resultContainer = document.getElementById("resultContainer");
const checkButton = document.getElementById("checkButton");
const zoomedImage = document.querySelector(".zoomed-image");
const cropPreviewTextEl = document.querySelector(".crop__preview-text");
const resetButton = document.getElementById("resetButton");
const spinnerEl = component.getSpinnerEl();
const cropWrapperEl = document.querySelector('.crop__wrapper');

let image = null;
let cropper = null;
const zoomFactor = 4;
const lensSize = 200;

fileInput?.addEventListener("change", (e) => {
  if (cropper) {
    reset();
  }

  cropWrapperEl.append(spinnerEl);

  const file = e.target.files[0];
  const fileName = file.name;
  const fileSize = file.size / 1024;

  const cropOptions = {
    viewMode: 1,
    checkOrientation: false,
    // movable: false,
    // scalable: false,
    // zoomable: false,

    // ready() {
    //   zoomedImage.style.backgroundImage = `url(${image.src})`;
    //   zoomedImage.style.backgroundSize = `${image.width * zoomFactor}px ${image.height * zoomFactor}px`;
    // }
  };
  const actions = ["e", "w", "s", "n", "se", "sw", "ne", "nw"];

  if (file) {
    const reader = new FileReader();

    reader.onload = (event) => {
      image = new Image();
      image.onload = () => {
        spinnerEl.remove();
        imageContainer.appendChild(image);
        cropper = new Cropper(image, cropOptions);

        const originalWidth = image.naturalWidth;
        const originalHeight = image.naturalHeight;

        cropPreviewTextEl.innerHTML = `
          <p>Имя файла: <b>${fileName}</b>, размер файла: <b>${fileSize.toFixed(2)}</b> кБ, разрешение файла: <b>${originalWidth} x ${originalHeight} px</b></p>
        `;
      };

      image.src = event.target.result;

      zoomedImage.style.backgroundImage = `url(${image.src})`;

      imageContainer.addEventListener("cropstart", (event) => {
        if (actions.includes(event.detail.action)) {
          onMouseMove(event.detail.originalEvent)
          zoomedImage.style.display = "block";
        }
      });
      imageContainer.addEventListener("cropmove", (event) => {
        if (actions.includes(event.detail.action)) {
          onMouseMove(event.detail.originalEvent)
          zoomedImage.style.display = "block";
        }
      });
      imageContainer.addEventListener("cropend", () => {
        zoomedImage.style.display = "none";
      });
    };

    reader.readAsDataURL(file);
  }
});


checkButton?.addEventListener("click", function() {
  if (cropper) {
    const croppedCanvas = cropper.getCroppedCanvas();
    const croppedBoxData = cropper.getCropBoxData();
    const croppedWidth = croppedCanvas.width;
    const croppedHeight = croppedCanvas.height;

    const outerContainer = document.createElement("div");
    outerContainer.className = "outer-container outer-container--mini";

    const innerContainer = document.createElement("div");
    innerContainer.className = "inner-container";

    const croppedImg = document.createElement("img");
    croppedImg.classList.add("crop__image");
    croppedImg.width = croppedWidth;
    croppedImg.height = croppedHeight;
    croppedImg.src = croppedCanvas.toDataURL();

    innerContainer.appendChild(croppedImg);
    outerContainer.appendChild(innerContainer);

    const data = cropper.getData();
    const width = Math.floor(data.width);
    const height = Math.floor(data.height);

    const label = document.createElement("div");
    label.className = "crop-label";
    label.textContent = `${width} × ${height} px`;

    // Позиционируем метку внизу справа изображения (можно менять по желанию)
    label.style.position = "absolute";
    label.style.bottom = "5px";
    label.style.right = "5px";

    // Стили для метки (фон, цвет, отступы)
    label.style.backgroundColor = "rgba(0, 0, 0, 0.6)";
    label.style.color = "#fff";
    label.style.padding = "2px 6px";
    label.style.fontSize = "12px";
    label.style.borderRadius = "3px";
    label.style.userSelect = "none";

    outerContainer.appendChild(label);

    const originImage = cropper.getImageData();
    const originWidth = originImage.naturalWidth;
    const originHeight = originImage.naturalHeight;

    const cropperCountPixels= Math.round(width * height);
    const originCountPixels= Math.round(originWidth * originHeight);

    const percent = cropperCountPixels / originCountPixels * 100;

    const wrapEl = document.createElement("li");
    wrapEl.classList.add("crop__list-item");

    const articleEl = document.createElement("article");
    articleEl.classList.add("crop-step");

    const resultEl = document.createElement("span");
    resultEl.innerHTML = `<span class="crop__note">${ percent.toFixed(2) } %</span>`;

    articleEl.append(outerContainer, resultEl);
    wrapEl.appendChild(articleEl);

    resultContainer.append(wrapEl);
  }
});


function onMouseMove(e) {
  const canvasData = cropper.getCanvasData();
  const imageData = cropper.getImageData();
  const rect = imageContainer.getBoundingClientRect();

  let x = e.clientX - rect.left - canvasData.left;
  let y = e.clientY - rect.top - canvasData.top;

  x = Math.max(0, Math.min(x, imageData.width));
  y = Math.max(0, Math.min(y, imageData.height));

  let left = e.pageX + 20;
  let top = e.pageY - lensSize / 2;

  zoomedImage.style.left = `${left}px`;
  zoomedImage.style.top = `${top}px`;

  const bgX = -x * zoomFactor + lensSize / 2;
  const bgY = -y * zoomFactor + lensSize / 2;

  zoomedImage.style.backgroundSize = `${imageData.width * zoomFactor}px ${imageData.height * zoomFactor}px`;
  zoomedImage.style.backgroundPosition = `${bgX}px ${bgY}px`;
}

resetButton.addEventListener("click", reset);

function reset() {
  imageContainer.innerHTML = "";
  cropPreviewTextEl.innerHTML = "";
  resultContainer.innerHTML = "";
  cropper.destroy();
  cropper = null;
}